export const CREATE_PURCHASE = 'CREATE_PURCHASE';
export const CREATE_PURCHASE_ERROR = 'CREATE_PURCHASE_ERROR';
export const CREATE_PURCHASE_REQUEST = 'CREATE_PURCHASE_REQUEST';
export const CREATE_PURCHASE_SUCCESS = 'CREATE_PURCHASE_SUCCESS';

export const DELETE_PURCHASE = 'DELETE_PURCHASE';
export const DELETE_PURCHASE_ERROR = 'DELETE_PURCHASE_ERROR';
export const DELETE_PURCHASE_REQUEST = 'DELETE_PURCHASE_REQUEST';
export const DELETE_PURCHASE_SUCCESS = 'DELETE_PURCHASE_SUCCESS';

export const EDIT_PURCHASE = 'EDIT_PURCHASE';
export const EDIT_PURCHASE_ERROR = 'EDIT_PURCHASE_ERROR';
export const EDIT_PURCHASE_REQUEST = 'EDIT_PURCHASE_REQUEST';
export const EDIT_PURCHASE_SUCCESS = 'EDIT_PURCHASE_SUCCESS';

export const GET_PURCHASE = 'GET_PURCHASE';
export const GET_PURCHASE_ERROR = 'GET_PURCHASE_ERROR';
export const GET_PURCHASE_REQUEST = 'GET_PURCHASE_REQUEST';
export const GET_PURCHASE_SUCCESS = 'GET_PURCHASE_SUCCESS';

export const GET_PURCHASES = 'GET_PURCHASES';
export const GET_PURCHASES_ERROR = 'GET_PURCHASES_ERROR';
export const GET_PURCHASES_REQUEST = 'GET_PURCHASES_REQUEST';
export const GET_PURCHASES_SUCCESS = 'GET_PURCHASES_SUCCESS';

export const RESTORE_PURCHASE = 'RESTORE_PURCHASE';
export const RESTORE_PURCHASE_ERROR = 'RESTORE_PURCHASE_ERROR';
export const RESTORE_PURCHASE_REQUEST = 'RESTORE_PURCHASE_REQUEST';
export const RESTORE_PURCHASE_SUCCESS = 'RESTORE_PURCHASE_SUCCESS';

export const SET_PURCHASE = 'SET_PURCHASE';
export const SET_PURCHASES = 'SET_PURCHASES';
